import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MatPaginator, MAT_DIALOG_DATA, PageEvent } from '@angular/material';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ConfiguracaoFamiliaOrcamento } from 'src/app/models/configuracao-familia-orcamento';
import { Filtro } from 'src/app/models/filtro';
import { Marca } from 'src/app/models/marca';
import { ItemPedido } from 'src/app/models/pedido';
import { Produto } from 'src/app/models/produto';
import { CarregandoService } from 'src/app/services/carregando.service';
import { MarcaService } from 'src/app/services/marca.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { ProdutoService } from 'src/app/services/produto.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { DetalheProdutoModalComponent } from '../detalhe-produto-modal/detalhe-produto-modal.component';
import { PaginatorService } from 'src/app/services/paginator.service';
import { ConfiguracaoCategoriaOrcamento } from "../../models/configuracao-categoria-orcamento";
import { CategoriaService } from "../../services/categoria.service";
declare const $: any;

@Component({
  selector: 'app-seleciona-produto-modal',
  templateUrl: './seleciona-produto-modal.component.html',
  styleUrls: ['./seleciona-produto-modal.component.scss']
})
export class SelecionaProdutoModalComponent implements OnInit {
  private alterouAbaSubscription: Subscription;
  configuracaoFamiliaOrcamento: ConfiguracaoFamiliaOrcamento;
  configuracaoCategoriaOrcamento: ConfiguracaoCategoriaOrcamento = new ConfiguracaoCategoriaOrcamento();

  itensFiltrados: ItemPedido[] = [];
  marcaSelecionada: number;
  marcas: Marca[];

  familia = 2;
  categoria = 2;

  tipo: string;
  carregando = true;
  ordenarDesc = false;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroDescricao: Filtro = { Propriedade: 'descricao', Valor: '' };
  filtros: Filtro[] = [this.filtroDescricao];
  campoOrdenacao = 'checado';
  public alterouAbaSubject: BehaviorSubject<any> = new BehaviorSubject<any>({});
  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    public dialogRef: MatDialogRef<SelecionaProdutoModalComponent>,
    private produtoService: ProdutoService,
    public utilitarioService: UtilitarioService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private marcaService: MarcaService,
    private paginatorService: PaginatorService,
    private categoriaService: CategoriaService,
  ) { }

  ngOnInit() {
    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.listarMarcas();
    this.buscarCategorias();

    this.configuracaoFamiliaOrcamento = {
      familias: [
        { 'idFamilia': '2', 'descricao': 'Painel', 'ordem': 1, 'visivel': true, 'icone': 'fas fa-solar-panel' },
        { 'idFamilia': '3', 'descricao': 'Inversor', 'ordem': 2, 'visivel': true, 'icone': 'fas fa-tablet' },
        { 'idFamilia': '5', 'descricao': 'Cabo', 'ordem': 3, 'visivel': true, 'icone': 'fas fa-plug' },
        { 'idFamilia': '4', 'descricao': 'Stringbox', 'ordem': 4, 'visivel': true, 'icone': 'fas fa-server' },
        { 'idFamilia': '6', 'descricao': 'Estrutura', 'ordem': 5, 'visivel': true, 'icone': 'fas fa-layer-group' },
        { 'idFamilia': '8', 'descricao': 'Transformador', 'ordem': 6, 'visivel': true, 'icone': 'fas fa-bolt' },
        { 'idFamilia': '9', 'descricao': 'Bateria', 'ordem': 7, 'visivel': true, 'icone': 'fa fa-battery-full' },
        { 'idFamilia': '1', 'descricao': 'Outro', 'ordem': 6, 'visivel': true, 'icone': 'fas fa-box' },]
    };

    this.alterouAbaSubscription = this.alterouAbaSubject.subscribe((dados: any) => {
      this.listarMarcas();
      this.buscarProdutos();
    });
  }

  buscarCategorias() {
    this.carregandoService.mostra('buscaCategorias');
    this.categoriaService.listar().subscribe((categorias: any[]) => {
        this.configuracaoCategoriaOrcamento.categorias = categorias.map(c => ({
          ...c,
          visivel: true
        }));


        console.log('Categorias: ', this.configuracaoCategoriaOrcamento);
      this.carregandoService.esconde('buscaCategorias');
    }, (erro) => {
      this.carregandoService.esconde('buscaCategorias');
      this.notificacaoService.erro(erro);
    });
  }

  alterouTab(index) {
    this.ativaAba(Number(this.configuracaoFamiliaOrcamento.familias[index].idFamilia));
  }

  ativaAba(fam) {
    this.familia = fam;
    this.alterouAbaSubject.next({ familia: this.familia === 10 ? 1 : this.familia });
  }

  fechar() {
    this.dialogRef.close();
  }

  retornaProduto() {
    // concatena todas as listas e retorna
    this.dialogRef.close();
  }

  listarMarcas() {
    this.carregandoService.mostra('buscaMarcas');

    this.marcaService.listarPorFamilia(Number(this.familia)).subscribe(
      (marcs) => {
        this.marcas = marcs;
        this.carregandoService.esconde('buscaMarcas');
      },
      (erro) => {
        this.carregandoService.esconde('buscaMarcas');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarProdutos() {
    this.carregandoService.mostra('buscaProduto' + this.tipo);
    this.carregando = true;

    this.produtoService.consultarComPaginacao(this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc', this.filtroDescricao.Valor, '', 'A', Number(this.familia), true, null, this.marcaSelecionada, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, 'A').subscribe(dados => {

      const produtos: Produto[] = dados.itens;
      this.itensFiltrados = [];

      produtos.forEach(p => {
        const novoItem = new ItemPedido();
        novoItem.pUnitario = p.precoVenda;
        novoItem.pCusto = p.precoCusto;
        novoItem.produto = p.idProduto;
        novoItem.produtoTela = p;
        novoItem.det1 = p.descricaoAtual;

        this.itensFiltrados.push(novoItem);

      });

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = dados.total;

      this.carregando = false;
      this.carregandoService.esconde('buscaProduto' + this.tipo);


    }, (erro) => {
      this.carregandoService.esconde('buscaProduto' + this.tipo);
    });
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;


      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarProdutos();
  }

  detalhesDoProduto(produto: Produto) {
    const largura = Number(($('body').width()));
    const dialogRef = this.dialog.open(DetalheProdutoModalComponent, {
      width: (($('body').width()).toString() + 'px'),
      // passa os produtos já selecionados
      data: {
        produto: produto
      },
      panelClass: 'modal-card',
      maxHeight: '90vh'
    });
  }

  filtra() {
    this.buscarProdutos();
    this.paginator.firstPage();
  }

  selecionaProduto(produto: any) {
    this.dialogRef.close(produto);
  }
}
